import React, { useState } from 'react'
import { Select } from 'antd'
import { useTranslation } from 'next-i18next'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { BigOrder, FilterDepositOption } from 'src/core/models'
import styles from '../../OrderListHeader.module.scss'
import { setFilteredOrders, orderListSelector, setFilterOrderText } from 'src/features'
const { Option } = Select

const filterOptions = {
  ALL: 'ALL',
  PAID: 'paid',
  PENDING: 'pending',
}

const FilterOrderByStatus = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const orderList = useAppSelector(orderListSelector)
  const [selectedFilter, setSelectedFilter] = useState(filterOptions.ALL)

  const handleChange = (value: FilterDepositOption) => {
    setSelectedFilter(value)
    const newOrderList: BigOrder[] = getNewDepositsFiltered(value)
    dispatch(setFilteredOrders(newOrderList))
  }

  const getNewDepositsFiltered = (option: FilterDepositOption): BigOrder[] => {
    dispatch(setFilterOrderText(null))
    if (option === 'ALL') return orderList
    return orderList.filter((d: BigOrder) => d.order.status === option)
  }

  return (
    <Select
      value={selectedFilter}
      onChange={handleChange}
      className={`${styles['btnAll']} margin-with`}
    >
      <Option value={filterOptions.ALL}>{t('Messages.All')}</Option>
      <Option value={filterOptions.PAID}>{t('Deposits.Completed')}</Option>
      <Option value={filterOptions.PENDING}>{t('Deposits.Pending')}</Option>
    </ Select>
  )
}

export default FilterOrderByStatus
